import React, { useState, useEffect } from 'react';
import { Button, TextField, Grid, Snackbar, Alert } from '@mui/material';
import { getDatabase, ref, push, set, get, remove } from 'firebase/database';
import Navbar from './Navbar';
import fc from '../firebaseConfig';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const db = getDatabase(fc);

const colorArray = [
  "#94651c", "#9d4730", "#853031", "#721043", "#3d2357", "#0b4453", "#2d5b55", "#606922"
];

const addEmployee = async (employee) => {
  const employeesRef = ref(db, 'employees');
  const newEmployeeRef = push(employeesRef);
  await set(newEmployeeRef, employee);
};

const fetchEmployees = async () => {
  const employeesRef = ref(db, 'employees');
  const snapshot = await get(employeesRef);
  const employees = [];
  if (snapshot.exists()) {
    snapshot.forEach((childSnapshot) => {
      employees.push({ id: childSnapshot.key, ...childSnapshot.val() });
    });
  }
  return employees;
};

const deleteEmployee = async (id) => {
  const employeeRef = ref(db, `employees/${id}`);
  await remove(employeeRef);
};

const AddEmployee = () => {
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [color, setColor] = useState('#94651c');
  const [employees, setEmployees] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const [showColorGrid, setShowColorGrid] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [nameError, setNameError] = useState(false);
  const [numberError, setNumberError] = useState(false);

  const navigate = useNavigate(); // Initialize navigate

  useEffect(() => {
    const checkLoggedIn = () => {
      if (!localStorage.getItem('LOGGED_IN')) {
        navigate('/'); // Redirect to home if not logged in
      }
    };
    checkLoggedIn();
    
    const getEmployees = async () => {
      const employeesList = await fetchEmployees();
      setEmployees(employeesList);
    };
    getEmployees();
  }, [navigate]);

  const handleSave = async () => {
    const phoneRegex = /^[0-9+]*$/;
    let hasError = false;

    if (!name) {
      setNameError(true);
      hasError = true;
    }

    if (!number || !phoneRegex.test(number)) {
      setNumberError(true);
      hasError = true;
    }

    if (hasError) {
      setErrorMessage('Należy wypełnić wszystkie pola!');
      return;
    }

    setErrorMessage('');
    setNameError(false);
    setNumberError(false);

    const employee = {
      name,
      number,
      color,
    };

    await addEmployee(employee);

    setName('');
    setNumber('');
    setColor('#94651c');

    const employeesList = await fetchEmployees();
    setEmployees(employeesList);

    setOpenSnackbar(true); // Show the success snackbar
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    setNameError(false); // Reset error state for name
  };

  const handleNumberChange = (e) => {
    setNumber(e.target.value);
    setNumberError(false); // Reset error state for number
  };

  const handleDelete = async () => {
    if (employeeToDelete) {
      await deleteEmployee(employeeToDelete.id);
      setOpenDialog(false);
      const employeesList = await fetchEmployees();
      setEmployees(employeesList);
    }
  };

  const openDeleteDialog = (employee) => {
    setEmployeeToDelete(employee);
    setOpenDialog(true);
  };

  const closeDeleteDialog = () => {
    setOpenDialog(false);
    setEmployeeToDelete(null);
  };

  const handleColorSelect = (selectedColor) => {
    setColor(selectedColor);
    setShowColorGrid(false);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <div>
      <Navbar />
      <h1 className='header' style={{ marginLeft: '27rem', marginTop: '4rem' }}>Dodaj Pracownika</h1>
      <Grid container spacing={2} style={{ maxWidth: '25rem', margin: '0 auto', textAlign: 'center', marginBottom: '70px' }}>
        <Grid item xs={12}>
          <TextField
            label="Imię i Nazwisko"
            variant="outlined"
            value={name}
            onChange={handleNameChange}
            fullWidth
            margin="normal"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: nameError ? 'red' : 'black',
                },
                '& input': {
                  color: nameError ? 'red' : 'black',
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Numer Telefonu"
            variant="outlined"
            value={number}
            onChange={handleNumberChange}
            fullWidth
            margin="normal"
            helperText="Tylko cyfry i znak '+' są dozwolone"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: numberError ? 'red' : 'black',
                },
                '& input': {
                  color: numberError ? 'red' : 'black',
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ marginTop: '10px' }}>
            <div
              onClick={() => setShowColorGrid(!showColorGrid)}
              style={{
                width: '100%',
                height: '2rem',
                backgroundColor: color,
                border: '2px solid black',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              <h5 style={{ marginTop: '-20px', marginLeft: '-280px' }}>Kolor pracownika</h5></div>
            {showColorGrid && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', marginTop: '10px', gap: '10px', width: '100%' }}>
                {colorArray.map((colorOption, index) => (
                  <div
                    key={index}
                    onClick={() => handleColorSelect(colorOption)}
                    style={{
                      width: '100%',
                      height: '40px',
                      backgroundColor: colorOption,
                      border: '2px solid black',
                      cursor: 'pointer'
                    }}
                  ></div>
                ))}
              </div>
            )}
          </div>
        </Grid>
        <Grid item xs={12}>
          {errorMessage && (
            <div style={{ color: 'red', marginBottom: '10px' }}>
              {errorMessage}
            </div>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            style={{ width: '60%', marginTop: '16px' }}
          >
            Zapisz Pracownika
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          borderRadius: '8px',
        }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%', color: 'white', backgroundColor: '#004d00' }}>
          Poprawnie dodano pracownika
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AddEmployee;
